import TextCreate from 'core/display/simple/Text'
import { FormatService } from 'services/FormatService'
import { signal } from 'services/SignalsService'

export default class PayoutText extends TextCreate{
  constructor(data) {
    super(data)

    const [id, count] = data.name.split('-')
    const payout = game.models.PayoutModel.getList()[id][count]

    signal.on('STATE:IN:FB-ADD', () => {
      let freeBetValue = game.models.FreebetsModel.get().betValue
      let winLinesQuantity = game.models.SpinModel.get().lines
      super.update(isNaN(payout) ? payout : FormatService.currency(freeBetValue * winLinesQuantity * payout))
    })

    signal.on('FREEBET:END', () => {
      super.update(isNaN(payout) ? payout : FormatService.currency(payout * game.models.BetModel.getValue()))
    })

    signal.on('MODEL:BET',  (bet) => {
      super.update(isNaN(payout) ? payout : FormatService.currency(payout * bet))
    })
  }
}
